import { rememberAttribution } from './signupAttribution';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';
import './piel.css';
import { rememberInvitation } from './invitation';
import { recordarAltaConAlexia } from './altaConAlexia';

// Antes de nada: el login puede redirigir y llevarse la URL por delante.
rememberInvitation();
rememberAttribution();
// Lo contestado en el chat de la landing llega en el fragmento (#alta=…).
recordarAltaConAlexia();

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).catch(() => {
      // La app sigue funcionando si el navegador impide la instalación.
    });
  });
}

const container = document.getElementById('root');
if (!container) throw new Error('No se ha encontrado el contenedor #root.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
